import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-medicine-card',
  imports: [],
  templateUrl: './skeleton-medicine-card.component.html',
  styleUrl: './skeleton-medicine-card.component.css'
})
export class SkeletonMedicineCardComponent {

}
